<template>
    <div>
        <b-btn class="font-weight-bold" variant="danger" @click="showOrder">Split Bill</b-btn>
        <b-modal centered hide-footer hide-header size="lg" scrollable v-model="modal" no-close-on-esc no-close-on-backdrop>
            <section class="py-1">
                <b-form-group size="lg" v-slot="{ ariaDescribedby }">
                    <div class="d-flex">
                        <b-form-radio :disabled="disableItem || order.SplitType === 'Amount'" size="lg" v-model="mode" :aria-describedby="ariaDescribedby" name="some-radios" value="item">By Item</b-form-radio>
                        <b-form-radio size="lg" style="margin-left: 150px" :disabled="order.SplitType === 'Item'" v-model="mode" :aria-describedby="ariaDescribedby" name="some-radios" value="amount">By Amount</b-form-radio>
                    </div>
                </b-form-group>
            </section>
            <section style="min-height: 550px">
                <div v-if="mode === 'item'">
                    <section>
                        <b-button-group size="lg">
                            <b-button @click="filterResult('all')" class="px-2" :class="filterStatus === 'all' ? 'activeBtn' : 'deactiveBtn'">
                                All
                            </b-button>
                            <b-button @click="filterResult('food')" class="px-2" :class="filterStatus === 'food' ? 'activeBtn' : 'deactiveBtn'">
                                Food
                            </b-button>
                            <b-button @click="filterResult('drink')" class="px-2" :class="filterStatus === 'drink' ? 'activeBtn' : 'deactiveBtn'">
                                Drink
                            </b-button>
                        </b-button-group>
                        <p class="text-danger mb-0 mt-4 font-weight-bold" v-if="order.Credit > 0">
                            This tab has applied credit and cannot be split by item.Remove tab credit to be able to split by item.
                        </p>
                    </section>
                    <section v-if="getData.length">
                        <div class="my-4 d-flex flex-row justify-content-between align-items-center border-bottom pb-4" v-for="item in getData">
                            <div class="">
                                <p class="mb-0" :class="item.DrinkID ? 'alcoholicText' : 'text-dark'">
                                    {{item.ItemName}}
                                    <span class="font-weight-bold mx-3">${{(item.Price / item.Quantity).toFixed(2)}}</span>
                                    <span v-if="item.Alcoholic" :class="item.Alcoholic ? 'alcoholicText' : 'text-dark'">
                            * ALC. VERIFY AGE *
                        </span>
                                </p>
                                <p v-if="item.PriceComment" class="mb-0 text-danger font-weight-bold">{{item.PriceComment}}</p>
                                <p v-if="item.Modifiers" style="color: red" class="mb-0">{{item.Modifiers}}</p>
                                <p v-if="item.Description" class="mb-0 text-danger font-weight-bold">{{item.Description}}</p>
                            </div>
                            <div>
                                <b-button-group size="sm" class="w-100">
                                    <b-button :disabled="order.Credit > 0 ? true : false" class="px-2" :variant="order.Credit > 0 ? 'secondary' : 'danger'" @click="subParty(item)">
                                        <font-awesome-icon icon="minus" class="align-middle"/>
                                    </b-button>
                                    <span class="px-3 py-1" style="background: #f1f1f1">
                                Party {{item.party}}
                            </span>
                                    <b-button :disabled="order.Credit > 0 ? true : false" class="px-2" :variant="order.Credit > 0 ? 'secondary' : 'success'" @click="addParty(item)">
                                        <font-awesome-icon icon="plus" class="align-middle"/>
                                    </b-button>
                                </b-button-group>
                            </div>
                        </div>
                    </section>
                    <section class="py-3" v-else>
                        No item available
                    </section>

                    <template>
                        <section v-if="errorText" class="text-danger mb-4 font-weight-bold">
                            Missing {{errorText}}. Assign item(s) to missing parties to proceed.
                        </section>
                    </template>
                </div>
                <div class="border-top pt-3" v-else>
                    <b-row class="justify-content-between">
                        <b-col cols="12" md="8">
                            <b-button-group size="md" class="w-100">
                                <b-button class="px-2" :class="splitAmount === 'equal' ? 'activeBtn' : 'deactiveBtn'" @click="splitAmount = 'equal'">
                                    Split Equally
                                </b-button>
                                <b-button class="px-2" :class="splitAmount === 'notEqual' ? 'activeBtn' : 'deactiveBtn'" @click="splitAmount = 'notEqual'">
                                    Split Unequally
                                </b-button>
                            </b-button-group>
                        </b-col>
                        <b-col cols="4" sm="6" md="4" class="mt-2 mt-md-0 d-flex align-items-center justify-content-end">
                            <span class="mr-2">Party Size</span>
                            <b-button-group size="md" class="">
                                <b-button class="px-2" variant="danger" @click="subPartyAmount">
                                    <font-awesome-icon icon="minus" class="align-middle"/>
                                </b-button>
                                <span class="py-2 px-4" style="background: #f1f1f1">
                                {{partyCount}}
                            </span>
                                <b-button class="px-2" variant="success" @click="addPartyAmount">
                                    <font-awesome-icon icon="plus" class="align-middle"/>
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" v-if="splitAmount === 'equal'">
                            <div class="mt-4">
                                <p>
                                    Each party's share post split will be the following
                                </p>
                                <p class="mb-0" style="color: #979797">
                                    Original Bill Subtotal: ${{order.Subtotal.toFixed(2)}}
                                    <span v-if="order.Credit > 0">
                                    (with ${{order.Credit.toFixed(2)}} applied credit)
                                </span>
                                </p>
                                <p>
                                    Adjusted Subtotal: ${{(getNewSubTotal).toFixed(2)}}
                                </p>
                                <p class="mb-0">
                                    Adjusted Tax: ${{(getNewTax).toFixed(2)}}
                                </p>
                                <p>
                                    Tip ({{(order.Tip_Percentage * 100).toFixed(2)}}%): ${{(getNewTip).toFixed(2)}}
                                </p>
                                <p class="mb-0">
                                    Tech Fee: ${{getTechFee}}
                                </p>
                                <p>
                                    Charge Amount: ${{(getChargeAmount).toFixed(2)}}
                                </p>
                            </div>
                        </b-col>
                        <b-col cols="12" v-else>
                            <div class="mt-4">
                                <p>
                                    Each party's share post split will be the following:
                                </p>
                            </div>
                            <div>
                                <b-table-simple striped hover responsive bordered>
                                    <b-thead>
                                        <b-tr>
                                            <b-th>Party</b-th>
                                            <b-th>Adjusted Subtotal</b-th>
                                            <b-th>Adjusted Tax</b-th>
<!--                                            <b-th>Tip ({{(order.Tip_Percentage * 100)}}%)</b-th>-->
                                            <b-th>Tip ({{(+order.Tip_Percentage * +sumNewSubTotal).toFixed(2)}}%)</b-th>
                                            <b-th>Tech Fee</b-th>
                                            <b-th>Charge Amount</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="item in unequal" :key="item.Party">
                                            <b-td>{{item.Party}}
                                            </b-td>
                                            <b-td class="d-flex align-items-center">
                                                <span class="mr-1">$</span>
                                                <numeric-input
                                                        no-seprator
                                                        style="max-width: 70px"
                                                        v-model="item.NewSubtotal"
                                                />
                                            </b-td>
                                            <b-td>
                                                ${{getTaxAmount(item.NewSubtotal).toFixed(2)}}
                                            </b-td>
                                            <b-td>
                                                ${{(+item.NewSubtotal * +order.Tip_Percentage).toFixed(2)}}
<!--                                                ${{(getNewTip).toFixed(2)}}-->
                                            </b-td>
                                            <b-td>
                                                ${{(getTechFeeAmount(item.NewSubtotal)).toFixed(2)}}
                                            </b-td>
                                            <b-td>
                                                {{(+item.NewSubtotal + getTaxAmount(item.NewSubtotal) + getNewTip + (getTechFeeAmount(item.NewSubtotal) / partyCount)).toFixed(2)}}
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                    <b-tfoot>
                                        <b-tr>
                                            <b-td colspan="2">
                                                <p class="mb-0 text-dark">
                                                    Sum of Adjusted Subtotals
                                                    <span></span>
                                                </p>
                                                <p class="mb-0" style="color: #979797">
                                                    Original Bill Subtotal
                                                    <span></span>
                                                </p>
                                                <p class="mb-0" style="color: rgba(135,50,17,0.76)">
                                                    Remaining Balance to Split
                                                    <span></span>
                                                </p>
                                            </b-td>
                                            <b-td colspan="4">
                                                <p class="mb-0 text-dark">
                                                <span>
                                                    ${{sumNewSubTotal.toFixed(2)}}
                                                </span>
                                                </p>
                                                <p class="mb-0" style="color: #979797">
                                                <span>
                                                    ${{order.Subtotal.toFixed(2)}}
                                                </span>
                                                    <span v-if="order.Credit > 0">
                                                    (with ${{order.Credit.toFixed(2)}} applied credit)
                                                </span>
                                                </p>
                                                <p class="mb-0" style="color: rgba(135,50,17,0.76)">
                                                <span>
                                                    ${{(order.Subtotal - sumNewSubTotal) <= 0 ? ((order.Subtotal - sumNewSubTotal)).toFixed(2) : Math.abs((order.Subtotal - sumNewSubTotal)).toFixed(2)}}
                                                </span>
                                                    <span class="text-danger ml-2 font-weight-bold" v-if="order.Subtotal - sumNewSubTotal < 0">
                                                    Remaining Balance to Split can NOT be less than zero.
                                                </span>
                                                </p>
                                            </b-td>
                                        </b-tr>
                                    </b-tfoot>
                                </b-table-simple>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </section>
            <section id="footer">
                <section v-if="mode === 'item'">
                    <b-btn
                        class="sendText"
                       :variant="errorText.length  || order.Credit > 0 ? 'secondary' : 'danger'"
                        :disabled="errorText.length || order.Credit || loading"
                        @click="splitOrder">
                        Split Bill
                    </b-btn>
                    <b-btn class="ml-2 lightGreen font-weight-bold" @click="sortData">Sort By Party</b-btn>
                    <b-btn class="ml-2 lightGreen font-weight-bold" @click="modal = false">Cancel</b-btn>
                </section>
                <section v-else>
                    <div v-if="disableItem && order.SplitType === 'Item'"></div>
                    <div v-else>
                        <b-btn v-if="splitAmount === 'equal'" variant="danger" :disabled="loading" class="sendText" @click="splitEqual">Split Bill</b-btn>
                        <b-btn
                                v-if="splitAmount === 'notEqual'"
                                :variant="loading || checkZiroField || checkSubTotalAndSumSubTotals ? 'secondary' : 'danger'"
                                :disabled="loading || checkZiroField || checkSubTotalAndSumSubTotals"
                                class="sendText"
                                @click="splitNotEqual">Split Bill</b-btn>
                        <b-btn class="ml-2 lightGreen font-weight-bold" @click="modal = false">Cancel</b-btn>
                    </div>
                </section>
                <div v-if="disableItem && order.SplitType === 'Item'">
                    <b-btn class="lightGreen font-weight-bold" @click="modal = false">Close</b-btn>
                </div>
            </section>
        </b-modal>
    </div>
</template>

<script>
    import NumericInput from "./NumericInput";
    export default {
        name: "splitBill",
        components: {
            NumericInput
        },
        props: {
            orderId: {
                required: true, type: [String, Number]
            },
            order: {
                required: true
            }
        },
        data () {
            return {
                mode: 'item',
                errorText: '',
                modal: false,
                items: [],
                billSplit: [],
                disableSplit: false,
                filterStatus: 'all',
                splitAmount: 'equal',
                partyCount: 2,
                loading: false,
                availableParty: 2,
                disableItem: false,
                lastChar: 1,
                unequal: [
                    {
                        Party: 1,
                        NewSubtotal: 0
                    },
                    {
                        Party: 2,
                        NewSubtotal: 0
                    }
                ],
                paidParty: []
            }
        },
        computed: {
            getData () {
                if (this.filterStatus === 'all') {
                    return this.billSplit
                }
                else if (this.filterStatus === 'food') {
                    return this.billSplit.filter(i => i.FoodID)
                } else {
                    return this.billSplit.filter(i => i.DrinkID)
                }
            },
            atLeaseAvaliableParty () {
                return this.billSplit.some(i => i.party > 1)
            },

            findPartyNumberOne () {
                return this.billSplit.some(i => i.party == 1)
            },

            getNewSubTotal () {
                return this.order.Subtotal / this.partyCount
            },
            getTechFee () {
                if (this.getNewSubTotal < 20) return 0.41
                if (this.getNewSubTotal >= 20 && this.getNewSubTotal <= 49.99) return 0.82
                if (this.getNewSubTotal >= 50) return 1.75
            },
            getNewTax () {
                return this.order.Tax / this.partyCount
            },
            getNewTip () {
                return +(this.order.Tip / this.partyCount)
            },
            getChargeAmount () {
                return this.getNewSubTotal + this.getNewTax + this.getNewTip + this.getTechFee
            },
            checkZiroField () {
                return this.unequal.some(i => !i.NewSubtotal)
            },
            sumNewSubTotal () {
                return this.unequal.reduce(function (acc, current) {
                    return Number(acc) + Number(current.NewSubtotal)
                }, 0);
            },
            checkSubTotalAndSumSubTotals () {
                return this.order.Subtotal.toFixed(2) !== this.sumNewSubTotal.toFixed(2)
            },

        },
        mounted () {
            console.log(this.order)
        },
        methods: {
            getTechFeeAmount (adjustedSubTotal) {
                if (adjustedSubTotal < 20) return 0.41
                if (adjustedSubTotal >= 20 && adjustedSubTotal <= 49.99) return 0.82
                if (adjustedSubTotal >= 50) return 1.75
            },
            getTaxAmount (adjustedSubTotal) {
                return +((adjustedSubTotal / this.order.Subtotal) * this.order.Tax)
            },
            showOrder () {
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId
                }
                Promise.all([
                    this.getOrderDetails(model),
                    this.getAvailableSplit(model),
                ]).then(res => {
                    const countItems = res[0]
                    const findOneItem = res[0].filter(i => i.Quantity === 1)
                    if (countItems.length === 1 && findOneItem.length === 1) {
                        this.mode = 'amount'
                        this.disableItem = true
                    } else {
                        if (this.order.SplitType === 'Amount') {
                            this.mode = 'amount'
                        } else if (this.order.SplitType === 'Item') {
                            this.mode = 'item'
                        } else {
                            this.mode = 'item'
                            this.disableItem = false
                        }
                    }
                    this.makeSplitData(res[0], res[1])
                })
            },
            getAvailableSplit(model) {
                return this.$api.getRestaurant.SplitRestaurantAvailableParty(model).then(res => {
                    if (res.success) {
                        this.availableParty = res.party
                        this.paidParty = res.orderPaidParties.map(item => {
                            return +item.PartyNo
                        })
                        return res.party
                    }
                }).catch(() => {})
            },
            getOrderDetails(model) {
                return this.$api.getRestaurant.GetRestaurantOrderDetail(model).then(res => {
                    if (res.success) {
                        return res.results.RestaurantOrderDetails
                    }
                }).catch(() => {

                })
            },
            makeSplitData (items, availableParty) {
                const lastChar = this.order.TabNo.substr(this.order.TabNo.length - 1)
                this.lastChar = lastChar
                let split = []
                items.forEach(item => {
                    for (let i = 0; i < item.Quantity; i++) {
                        let newItem = {...item}
                        newItem.uId = Math.floor(Math.random() * 10000)
                        split.push(newItem)
                    }
                })
                split.forEach((item) => {
                    this.$set(item, 'party', lastChar)
                    this.$set(item, 'valid', true)
                })
                this.billSplit = split
                this.modal = true
            },
            addParty (item) {
                if (item.party < 20) {
                    if (item.party == this.lastChar) {
                        item.party = this.availableParty
                        this.$nextTick(() => {
                            this.sortTemporary()
                        })
                    } else {
                        // paidParty
                        item.party = this.nextUnpaidParty(item.party)
                        this.$nextTick(() => {
                            this.sortTemporary()
                        })
                    }
                }
            },
            nextUnpaidParty (value) {
                const nextVal = +value + 1
                if (!this.paidParty.find(item => item == nextVal)) return nextVal
                else return this.nextUnpaidParty(nextVal)
            },
            prevUnpaidParty (value) {
                const nextVal = +value - 1
                if (!this.paidParty.find(item => item == nextVal)) return nextVal
                else return this.prevUnpaidParty(nextVal)
            },


            subParty (item) {
                if (item.party == this.availableParty) {
                    item.party = this.lastChar
                    this.$nextTick(() => {
                        this.sortTemporary()
                    })
                } else {
                    if (item.party > this.lastChar) {
                        item.party = this.prevUnpaidParty(item.party)
                        this.$nextTick(() => {
                            this.sortTemporary()
                        })
                    }
                }
            },
            sortTemporary () {
                const copy = this.billSplit.map(item => ({...item}))
                const sorted = copy.sort((a,b) => {
                    return b.party - a.party
                })
                sorted.forEach((item, index) => {
                    if (sorted[index + 1]) {
                        if (sorted[index].party - sorted[index + 1].party > 1) {
                            sorted[index + 1].valid = false
                        } else {
                            sorted[index + 1].valid = true
                        }
                    }
                })


                if (sorted.filter(i => !i.valid).length) {
                    this.disableSplit = true
                } else {
                    this.disableSplit = false
                }
                this.showUnUsedParty(sorted)
            },
            showUnUsedParty (sortedData) {
                const temp = sortedData.map(item => {
                    return item.party
                })
                const min = Math.min(...temp)
                const max = Math.max(...temp)
                let list = []
                for (var i = min; i <= max - 1; i++) {
                    if (i !== min && (!temp.find(item => item == i)) && i >= this.availableParty && (!this.paidParty.find(item => item == i))) {
                        list.push('Party ' + i);
                    }
                }
                this.errorText = list.join(' & ')
                // if (this.disableSplit) {
                //     const temp = sortedData.map(item => {
                //         return item.party
                //     })
                //     const min = Math.min(...temp)
                //     const max = Math.max(...temp)
                //     let list = []
                //     for (var i = min; i <= max - 1; i++) {
                //         if (i !== min && (!temp.find(item => item == i)) && i >= this.availableParty) {
                //             list.push('Party ' + i);
                //         }
                //     }
                //     this.errorText = list.join(' & ')
                // } else {
                //     this.errorText = ''
                // }
            },
            sortData () {
                this.billSplit = this.billSplit.sort((a,b) => {
                    return b.party - a.party
                })
            },
            filterResult (filterStatus) {
                this.filterStatus = filterStatus
            },
            splitOrder () {
                const model = this.billSplit
                const obj = {}
                model.forEach(item => {
                    obj[item.party] = {
                        item: model.filter(i => i.party === item.party).map(j => {return j.IKey})
                    }
                })
                let arr = []
                for (let key in obj)  {
                    if (+key != this.lastChar) {
                        arr.push({
                            Party: +key,
                            OrderDetailString: (obj[key].item).join(',')
                        })
                    }
                }
                const body = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId,
                    Parties: arr
                }
                this.loading = true
                return this.$api.getRestaurant.SplitRestaurantOrderyItem(body).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.$emit('refresh')
                        this.modal = false
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            addPartyAmount () {
                if (this.partyCount < 20) {
                    this.partyCount ++
                    this.unequal.push(
                        {
                            Party: this.partyCount,
                            NewSubtotal: 0
                        }
                    )
                }
            },
            subPartyAmount () {
                if (this.partyCount > 2) {
                    this.partyCount --
                    this.unequal.splice(this.unequal.length - 1, 1)
                }
            },
            splitEqual () {
                const array = []
                for (let i = 2 ; i <= this.partyCount; i++) {
                    array.push({
                        Party: i,
                        NewSubtotal: (this.getNewSubTotal).toFixed(2)
                    })
                }
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId,
                    Parties: array
                }
                this.$showConfirm(undefined, 'Are you sure you want to split this order?').then(() => {
                    this.loading = true
                    return this.$api.getRestaurant.SplitRestaurantOrderByAmount(model).then(res => {
                        this.loading = false
                        if (res.success) {
                            this.$emit('refresh')
                            this.modal = false
                        } else {
                            this.$showError(res.message)
                        }
                    })
                })
            },
            splitNotEqual () {
                const model = this.unequal.map((item, index) => {
                    return {
                        Party: index + 1,
                        NewSubtotal: item.NewSubtotal,
                    }
                })
                const data = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId,
                    Parties: model.filter(i => i.Party !== 1)
                }
                this.$showConfirm(undefined, 'Are you sure you want to split this order?').then(() => {
                    this.loading = true
                    return this.$api.getRestaurant.SplitRestaurantOrderByAmount(data).then(res => {
                        this.loading = false
                        if (res.success) {
                            this.$emit('refresh')
                            this.modal = false
                        } else {
                            this.$showError(res.message)
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
    .alcoholicText {
        color: #3d5afe;
    }
    .lightGreen{
        background: #b5e51f !important;
        color: #fff !important;
    }
</style>
